import {PublicConfig} from "~/utils/types/config"
import {useCheckoutStore} from "~/store/checkout"
import {Composer, ExportedGlobalComposer} from "vue-i18n"
import type {NuxtI18nRoutingCustomProperties} from "@nuxtjs/i18n/dist/runtime/types"
import type {LocaleObject} from "@nuxtjs/i18n"
import {EventVisibility} from "~/utils/types/event.d"
import {useUtilStore} from "~/store/util";

export const navigateToEvent = async function (){
  const config: PublicConfig = useRuntimeConfig().public as PublicConfig
  const checkout = useCheckoutStore()
  const {locale}  = useNuxtApp().$i18n as ExportedGlobalComposer & Composer & NuxtI18nRoutingCustomProperties<LocaleObject[]>
  const route = useRoute();

  if (checkout.event.visibility === EventVisibility.private) {
    return navigateTo(location.href, {external: true});
  }

  let url = `${config.eventpage_url}/${locale.value}/event/${checkout.event.alias}`; 
  
  await navigateTo({
    path: url,
    query: route.query
  }, {
    external: true
  });
}

export const navigateToSummary = async function (slug: string){

  const utils = useUtilStore()
  if (utils.isSummaryPage) return Promise.resolve()

  const {locale}  = useNuxtApp().$i18n as ExportedGlobalComposer & Composer & NuxtI18nRoutingCustomProperties<LocaleObject[]>

  const requestURL = useRequestURL()

  return navigateTo(`${requestURL.origin}/${locale.value}/${slug}/summary`, {external: true});
}
